import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sim-detail-group',
  imports: [],
  template: '<ng-content />',
  styleUrl: './detail-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'detail-group'
  }
})
export class SimDetailGroupComponent {}
